import { render, staticRenderFns } from "./ProductLog.vue?vue&type=template&id=0aabe412&"
import script from "./ProductLog.vue?vue&type=script&lang=js&"
export * from "./ProductLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports